// extracted by mini-css-extract-plugin
export default {"product_cart_img":"ProductCart_product_cart_img__qXSqy"};